import { render } from "./UploadInventoryStocksModal.vue?vue&type=template&id=32471f58"
import script from "./UploadInventoryStocksModal.vue?vue&type=script&lang=js"
export * from "./UploadInventoryStocksModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__